export default __webpack_public_path__ + "static/ProServices-hero-a636d8f9ce0b1aa3bb298742130e2f7b.png";